'use strict';
var dialog = require('../../dialog'),
	productStoreInventory = require('../../storeinventory/product'),
	util = require('../../util'),
	einstein = require('../../einstein'),
	addToCart = require('./addToCart'),
	availability = require('./availability'),
	image = require('./image'),
	productNav = require('./productNav'),
	productTabs = require('./producttabs'),
	productSet = require('./productSet'),
	recommendations = require('./recommendations'),
	variant = require('./variant'),
	sleeve = require('./sleeve'),
	component = require('./component'),
	componentQuickview = require('./componentQuickview'),
	quantity = require('./quantity'),
	alterUpsell = require('./alterUpsell'),
	lcgResponsive = require('../../lcg_responsive'),
	jcalendar = require('../../jcalendar'),
	checkStoreStock = require('./checkStoreStock'),
	backInStock = require('./backInStock'),
	giftcert = require('../../giftcert'),
	specialClub = require('./specialClub'),
	recipe = require('./recipe'),
	ordergroove = require('int_ordergroove/ordergroove/product'),
	pdpRecommendations = require('./pdpRecommendations'),
	iscroll = require('../../iscroll');

var fireReadyResize = function () {

	// Activates PDP component object
	if (util.viewport.isTablet() === true) {
		component.init(3);
	} else if (util.viewport.isLarge() === true) {
		component.init(4);
	} else {
		component.init(5);
	}

	//relocate pdp tabs
	if (util.viewport.isMobile() && $('.menu-mobile').find('.component-content').length === 0 || !util.viewport.isMobile() && $('.component-wrapper').find('.component-content').length === 0) {
		lcgResponsive.move(util.viewport.isMobile(), '.component-content', '.menu-mobile', '.component-wrapper');
	}
	lcgResponsive.move(util.viewport.isMobile(), '.product-setlist-wrapper', '.product-setlist-mobile', '.product-setlist-desktop');
};


/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {

	productTabs.init();
	productNav();
	recommendations();
	fireReadyResize();
	$(window).smartresize(fireReadyResize);
	// Activate Quantity Selector
	quantity.init();
	alterUpsell.init();
	ordergroove.setProduct();
	pdpRecommendations.init();
}

/**
 * @description open reviews tab before click is fired on BV ratings stars
 */
var PDPBVInlineRatings = function () {
	var PDPInlineRatings = $('#inlineRatings');
	if (PDPInlineRatings.length) {
		$('#BVRRSummaryContainer').on('click', '.bv-rating-stars', scrollToReviews);
	} else if ($('.review-link').length > 0) {
		// BV link anchors & triggers product review tabs
		$('.review-link').on('click', scrollToReviews);
	}
};

function scrollToReviews () {
	var $reviewsTab = util.viewport.isMobile() ? $('.reviews.tab-mobile-title') : $('.reviews.ui-tabs-anchor');
	var scrollTopToReviews = util.viewport.isMobile() ? $reviewsTab.offset().top - 75 : $reviewsTab.offset().top;
	$('html').animate({
		scrollTop: scrollTopToReviews
	}, 500, function () {
		if (!$reviewsTab.hasClass('active')) {
			$reviewsTab.trigger('click');
			$(this).removeAttr('href');
		}
	});
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
	var $pdpMain = $('#pdpMain');
	addToCart();
	availability();
	variant();
	image();
	productSet();
	checkStoreStock();
	backInStock();
	sleeve.init();
	giftcert.init();
	componentQuickview.init();
	specialClub.init();
	jcalendar.init($('.datepicker-giftcard'), {
		'calendarClass': 'gift-cart-calendar',
		'container': $('.gc-date-wrapper')
	});

	// Init only if this is recipe PDP
	if ($('.product-detail .product-recipe').length > 0) {
		recipe.init();
	}
	PDPBVInlineRatings();

	if (SitePreferences.STORE_PICKUP) {
		productStoreInventory.init();
	}
	// override date-picker input field
	$('.send-date').prop('readonly', true);

	// Activates slick slider for PDP recommendations
	$('.recommendations-a #carousel-recommendations').slick(util.sliderConfigs({instandard:4, inlarge:3, inmedium:2, insmall:1}));

	$('.recommendations-b #carousel-recommendations').slick(util.sliderConfigs({instandard:2, inlarge:1, inmedium:1}));

	$('.recommendations-pi #carousel-recommendations').slick(util.sliderConfigs({instandard:4, inlarge:3, inmedium:2, insmall:1}));

	einstein.onEinstainContentAdded('.recommendations-pdp', function () {
		$('.recommendations-pdp #carousel-recommendations').slick(util.sliderConfigs({instandard:4, inlarge:3, inmedium:2, insmall:1}));
	});
	// Checks if product list is quickview
	if (!$('.quickView-prod-set').length) {
		// Activates slick slider for product sets
		$('.product-set-content').slick(util.sliderConfigs({instandard:4, inlarge:3, inmedium:2, insmall:1}));
	}

	$('.recipe-content').slick({infinite: false});

	// Simulate add all button click in mobile
	$('#product-set-btn-mobile').on('click touchstart', function (e) {
		e.preventDefault();
		$('#add-all-to-cart').trigger('click');
	});

	// Removes "additional container" if empty
	if ($('.descSection3.additional li').length < 1) {
		$('.descSection3.additional').hide();
	}

	// Toggles tab content on click
	$('.descSection3 h3').on('click touchstart', function (e) {
		$(this).toggleClass('active');
		e.preventDefault();
	});

	// Toggles product info content on click
	$('.prod-info h4').on('click touchstart', function (e) {
		$(this).toggleClass('active');
		e.preventDefault();
	});

	// Add to Wishlist and Add to Gift Registry links behaviors
	$pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
		var data = util.getQueryStringParams($('.pdpForm').serialize());
		if (data.cartAction) {
			delete data.cartAction;
		}
		var url = util.appendParamsToUrl(this.href, data);
		this.setAttribute('href', url);
	});

	// product options
	$pdpMain.on('change', '.product-options select', function () {
		var salesPrice = $pdpMain.find('.product-detail .price-sales');
		var selectedItem = $(this).children().filter(':selected').first();
		salesPrice.text(selectedItem.data('combined'));
	});

	// prevent default behavior of thumbnail link and add this Button
	$pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
		e.preventDefault();
	});

	/*globals $BV, rrConfigData*/
	//show reviews in review tabs
	var showReviews = setInterval(function() {
		if (typeof $BV !== 'undefined' && typeof rrConfigData !== 'undefined') {
			$BV.ui('rr', 'show_reviews', rrConfigData);
			clearInterval(showReviews);
		}
	}, 200);

	//open review if it's redirect from the qv
	if (window.location.hash.substr(1) === 'qv-review') {
		$('html, body').animate({
			scrollTop: $('.reviews').offset().top
		}, 500, function () {
			if (rrConfigData.productId) {
				$BV.ui("rr", "submit_review", {productId: rrConfigData.productId});
			}
		});
	}

	// Physical gift card amount field
	$('input[name$="amount"]').on('focus', function () {
		// Remove error messages on focus
		$(this).closest('form').find('span.error').remove();
		$(this).closest('form').find('input.error, div.error').removeClass('error');
		$(this).closest('form').find('.error-message').remove();
	});

	// Remove error messages on pdp load
	$('input.error, div.error').removeClass('error');
	$('.error-message').remove();


	//drop a hint handler
	$('.drop-a-hint > a').click(function (e) {
		e.preventDefault();
		dialog.open({
			url:$(this).attr('href'),
			options: {
				dialogClass: 'drop-a-hint-dialog',
				open: function () {
					setTimeout(function () {
						util.limitCharatersCounter();
						util.limitCharacters();
						$('.drop-a-hint-dialog').find('input:checkbox').prop('checked', true).uniform();
						$('.drop-a-hint-dialog').on('click', '[name$=send]', function (e) {
							e.preventDefault();
							dialog.submit($(this).attr('name'), function () {
								util.limitCharatersCounter();
								util.limitCharacters();
							});
						});
						$('.drop-a-hint-dialog').on('click', '.close-it', function () {
							dialog.close();
						});
					}, 40);
				},
				close: function () {
					$('.drop-a-hint-dialog').off('click', '[name$=send]');
					$('.drop-a-hint-dialog').off('keydown change keyup mouseup', 'textarea[data-character-limit]');
				},
				buttons: []
			}
		});
	});

	// On Write a Review button click add Hotel Chocolat Score Medal
	$('body').on('click', '.bv-submission-button-submit', function () {
		$.ajax({
			url: Urls.productReviewScoreMedal
		});
	});

	initOpenSidePanel();

	$('body').on('change', 'textarea, input.input-text', function () {
		this.value = util.removeInvalidChars(this.value);
	});
}


/**
 * @private
 * @function
 * @description Adds listner to open side panel on PDP
 */
function initOpenSidePanel() {
	$(document).on('click', '.js-open-side-panel', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var dialogContent = $(this).parents('.side-panel-wrapper').find('.js-dialog-content');
		if (!dialogContent.length) {
			return;
		}
		$('body').addClass('no-scroll');
		dialog.open({
			html: dialogContent.html(),
			options: {
				show: 'drop',
				position: {
					my: 'right top',
					at: 'right top',
					of: window
				},
				height: window.innerHeight,
				dialogClass: 'js-side-panel',
				open: function() {
					$('.js-side-panel').find('.close-button').on('click', function() {
						dialog.close();
					});

					var scrollingContentNeeded = $(this).find('.inner-wrapper').height() > $(this).height();
					if (scrollingContentNeeded) {
						var $iscrollWrapper = $('.dialog-content .iscroll-wrapper');
						$iscrollWrapper.css('height', $(this).height());
						$iscrollWrapper.addClass('scroll');
						iscroll.init();
					}
				},
				close: function() {
					$('body').removeClass('no-scroll');
					var iscrollWrapper = $(this).find('.iscroll-wrapper');
					if (iscrollWrapper.hasClass('scroll')) {
						iscrollWrapper.removeClass('scroll');
						$('.iScrollVerticalScrollbar').remove();
					}
				}
			}
		});
	});
}

var product = {
	initializeDom: initializeDom,
	initializeEvents: initializeEvents,
	init: function () {
		initializeDom();
		initializeEvents();

		// binds variation product changing, triggers a complete re-init since
		// entire PDP details section is re-loaded
		$(document).off('productVariationChanged');
		$(document).on('productVariationChanged', function () {
			product.initializeDom();
			product.initializeEvents();
		});
	}
};

module.exports = product;
